import React from "react";
import { LoaderCircle } from "lucide-react";

const LoadingPanel = ({ size = 24, children }) => {
  return (
    <div className="flex h-full w-full animate-pulse items-center justify-center gap-4 text-lg">
      <LoaderCircle size={size} className="animate-spin text-slate-400" />
      {children}
    </div>
  );
};

export default LoadingPanel;
